module.exports = __webpack_public_path__ + "img/set.18fadcaa.png";